(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fts-back-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-fts-back]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  try {
    const previous = new URL(document.referrer);
    if (previous.origin === window.location.origin && previous.pathname !== window.location.pathname && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  } catch {}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fts-shirt-wheel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fts-shirt-wheel')){
  customElements.define('fts-shirt-wheel',class extends HTMLElement{
    async connectedCallback(){
      if(this.started)return;
      this.started=true;
      this.abort=new AbortController();
      const signal=this.abort.signal;
      this.track=this.querySelector('.fts-wheel__products');
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      if(this.dataset.sorted==='true'){
        try{
          const url=new URL(this.dataset.url,location.origin);
          url.searchParams.set('sort_by','best-selling');
          url.searchParams.set('section_id',this.dataset.section);
          const preview=new URLSearchParams(location.search).get('preview_theme_id');
          if(preview)url.searchParams.set('preview_theme_id',preview);
          const response=await fetch(url,{signal});
          if(!response.ok)throw Error('Section unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const sorted=doc.querySelector('.fts-wheel__products');
          if(sorted?.children.length)this.track.replaceChildren(...sorted.children);
        }catch(error){if(error.name==='AbortError')return;}
      }
      if(!this.isConnected)return;
      this.cards=[...this.track.children].slice(0,Number(this.dataset.limit));
      this.track.replaceChildren(...this.cards);
      if(!this.cards.length)return;
      this.previous=this.querySelector('[data-prev]');
      this.next=this.querySelector('[data-next]');
      this.count=this.querySelector('.fts-wheel__count');
      this.pauseButton=this.querySelector('[data-pause]');
      this.paused=this.dataset.auto!=='true'||this.motion.matches;
      this.pauseButton.hidden=this.dataset.auto!=='true';
      this.querySelector('.fts-wheel__controls').hidden=false;
      this.previous.addEventListener('click',()=>{this.stop();this.move(-1);},{signal});
      this.next.addEventListener('click',()=>{this.stop();this.move(1);},{signal});
      this.track.addEventListener('scroll',()=>this.update(),{passive:true,signal});
      this.track.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();this.stop();
        if(event.key==='Home'||event.key==='End')this.go(event.key==='Home'?0:this.track.scrollWidth-this.track.clientWidth);
        else this.move(event.key==='ArrowLeft'?-1:1);
      },{signal});
      this.track.addEventListener('pointerdown',event=>{
        this.stop();
        if(event.pointerType!=='mouse'||event.button!==0)return;
        this.drag={id:event.pointerId,x:event.clientX,scroll:this.track.scrollLeft,moved:false};
      },{signal});
      this.track.addEventListener('pointermove',event=>{
        if(!this.drag||this.drag.id!==event.pointerId)return;
        const distance=event.clientX-this.drag.x;
        if(Math.abs(distance)>6){this.drag.moved=true;this.track.classList.add('is-dragging');this.track.setPointerCapture(event.pointerId);this.track.scrollLeft=this.drag.scroll-distance;}
      },{signal});
      const release=()=>{if(!this.drag)return;const moved=this.drag.moved;this.drag=null;this.track.classList.remove('is-dragging');if(moved){this.suppressClick=true;setTimeout(()=>{this.suppressClick=false;},0);}};
      this.track.addEventListener('pointerup',release,{signal});
      this.track.addEventListener('pointercancel',release,{signal});
      this.track.addEventListener('click',event=>{if(this.suppressClick){event.preventDefault();event.stopPropagation();}},{capture:true,signal});
      this.track.addEventListener('dragstart',event=>event.preventDefault(),{signal});
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.pauseLabel();this.timer();},{signal});
      this.addEventListener('focusin',event=>{if(event.target!==this.pauseButton)this.stop();},{signal});
      this.addEventListener('mouseenter',()=>{this.hovered=true;},{signal});
      this.addEventListener('mouseleave',()=>{this.hovered=false;},{signal});
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.stop();},{signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;});this.observer.observe(this);
      this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);
      this.update();this.pauseLabel();this.timer();
    }
    stride(){return this.cards.length>1?this.cards[1].offsetLeft-this.cards[0].offsetLeft:this.cards[0].offsetWidth;}
    move(direction){const index=Math.round(this.track.scrollLeft/this.stride());this.go((index+direction)*this.stride());}
    go(left){this.track.scrollTo({left:Math.max(0,Math.min(left,this.track.scrollWidth-this.track.clientWidth)),behavior:this.motion.matches?'instant':'smooth'});}
    update(){
      if(!this.cards?.length)return;
      const left=this.track.scrollLeft,max=this.track.scrollWidth-this.track.clientWidth;
      this.previous.disabled=left<=8;this.next.disabled=left>=max-8;
      const viewport=this.track.getBoundingClientRect();
      const visible=this.cards.map((card,index)=>({index,rect:card.getBoundingClientRect()})).filter(({rect})=>rect.right>viewport.left+rect.width/2&&rect.left<viewport.right-rect.width/2);
      const first=visible[0]?.index||0;
      const last=(visible.at(-1)?.index??first)+1;
      this.count.textContent=(first+1)+(last>first+1?'–'+last:'')+' / '+this.cards.length;
    }
    pauseLabel(){this.pauseButton.textContent=this.querySelector(this.paused?'[data-play-text]':'[data-pause-text]').textContent;}
    stop(){this.paused=true;this.pauseLabel();clearInterval(this.interval);}
    timer(){clearInterval(this.interval);if(!this.paused)this.interval=setInterval(()=>{if(this.visible&&!this.hovered&&!document.hidden){if(this.next.disabled)this.go(0);else this.move(1);}},Number(this.dataset.speed)*1000);}
    disconnectedCallback(){this.abort?.abort();clearInterval(this.interval);this.observer?.disconnect();this.resize?.disconnect();this.started=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
